import { BondDepartmentModel } from "app/pages/collaborators/models/BondDepartmentModel";
import { BondsDepartmentAllResponse } from "app/types/asignacion_bonos";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_NET;

export async function getAllBondsDepartment(page: number | string, pageSize: number | string, nameDepartment?: string) {
  try {
    const url = nameDepartment
      ? `${API_URL}BondsDepartment?DepartmentName=${nameDepartment}&page=${page}&pageSize=${pageSize}`
      : `${API_URL}BondsDepartment?page=${page}&pageSize=${pageSize}`;

    const response = await axios.get<BondsDepartmentAllResponse>(url);
    return response.data.data;
  } catch (err) {
    console.error("Error fetching BondsDepartment");
    throw err;
  }
}

export async function updateBondDepartment(body: BondDepartmentModel, id: any) {
  let response;
  try {
    response = await axios.put(`${API_URL}BondsDepartment/${id}/update`, body);
    return response.data;
  } catch (err) {
    console.error("Error en actualizar el BondDepartment:", err);
    throw err;
  }
}

export async function updateBondDepartmentCollaborator(id: any, porcent: any, bondAmount: any, bondFinal: any) {
  let response;
  try {
    response = await axios.put(`${API_URL}BondsDepartment/PutBondCollaboratorDepartment?Id=${id}&Porcent=${porcent}&BondAmount=${bondAmount}&BondFinal=${bondFinal}`);
    return response.data;
  } catch (err) {
    console.error("Error en actualizar el PutBondCollaboratorDepartment:", err);
    throw err;
  }
}